(function () {
  const config = document.getElementById('LulloShippingConfig');
  if (!config || config.dataset.country !== 'US' || config.dataset.currency !== 'USD') return;

  const threshold = Number(config.dataset.threshold || 0);
  if (!Number.isFinite(threshold) || threshold <= 0) return;

  const formatUsd = (cents) =>
    new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: cents % 100 === 0 ? 0 : 2,
      maximumFractionDigits: 2,
    }).format(cents / 100);

  const parseUsd = (value) => {
    const amount = Number.parseFloat(String(value || '').replace(/[^0-9.-]/g, ''));
    return Number.isFinite(amount) ? Math.round(amount * 100) : null;
  };

  const updateAtlasProgress = () => {
    const host = document.querySelector('.atlas-upsell-cart-progress-reward-container');
    const subtotal = document.getElementById('atlas-upsell-cart-subtotal-line-price-span');
    if (!host || !subtotal) return;

    const total = parseUsd(subtotal.textContent);
    if (total === null) return;
    if (host.dataset.lulloTotal === String(total) && host.querySelector('.lullo-shipping-progress--atlas')) return;

    const remaining = Math.max(threshold - total, 0);
    const progress = Math.min(Math.max((total / threshold) * 100, 0), 100);
    const status = remaining > 0
      ? `Add ${formatUsd(remaining)} more to unlock free US shipping.`
      : 'Free US shipping unlocked.';

    host.dataset.lulloTotal = String(total);
    host.style.display = 'block';
    host.innerHTML = `
      <div class="lullo-shipping-progress lullo-shipping-progress--atlas">
        <p class="lullo-shipping-progress__text" role="status" aria-live="polite" aria-atomic="true">${status}</p>
        <div class="lullo-shipping-progress__track" role="progressbar" aria-label="Free US shipping progress" aria-valuemin="0" aria-valuemax="100" aria-valuenow="${Math.round(progress)}" aria-valuetext="${status}">
          <span class="lullo-shipping-progress__fill" style="--lullo-shipping-progress: ${progress}%;"></span>
        </div>
        <div class="lullo-shipping-progress__meta" aria-hidden="true">
          <span>${formatUsd(total)}</span>
          <span>${formatUsd(threshold)} goal</span>
        </div>
      </div>`;
  };

  let updateQueued = false;
  const queueUpdate = () => {
    if (updateQueued) return;
    updateQueued = true;
    window.requestAnimationFrame(() => {
      updateQueued = false;
      updateAtlasProgress();
    });
  };

  const observer = new MutationObserver(queueUpdate);
  observer.observe(document.documentElement, { childList: true, subtree: true, characterData: true });
  document.addEventListener('cart:update', queueUpdate);
  document.addEventListener('DOMContentLoaded', queueUpdate, { once: true });
  queueUpdate();
})();
